import {SettingsAction} from '../types';
import {WorkspaceSettingsController} from '../hooks/useWorkspaceSettings';
import {Btn, Spinner} from './Shared';
import {Dialog, DialogContent, DialogTitle, DialogDescription} from './ui/dialog';

interface ConfirmationCopy {title: string; description: string; action: string}
const confirmationCopy: Record<Exclude<SettingsAction, null>, ConfirmationCopy> = {
  samples: {title: 'Clear sample data?', description: 'Only sample tickets, sample articles, and their feedback will be removed. Your own content will stay.', action: 'Clear samples'},
  workspace: {title: 'Delete this workspace?', description: 'This permanently removes all workspace data and disconnects Gmail. This action cannot be undone.', action: 'Delete workspace'},
};

export const SettingsConfirmation = ({settings}: {settings: WorkspaceSettingsController}) => {
  if (!settings.confirm) return null;
  const copy = confirmationCopy[settings.confirm];
  return <Dialog open onOpenChange={open => { if (!open && !settings.busy) settings.setConfirm(null); }}>
    <DialogContent className="app-modal" data-testid="settings-confirm-modal">
      <DialogTitle data-testid="settings-confirm-title">{copy.title}</DialogTitle><DialogDescription data-description="true" data-testid="settings-confirm-description">{copy.description}</DialogDescription>
      <div className="form-footer"><Btn onClick={() => settings.setConfirm(null)} disabled={settings.busy} data-testid="settings-confirm-cancel">Cancel</Btn><Btn className="danger-button" onClick={settings.perform} disabled={settings.busy} data-testid="settings-confirm-submit">{settings.busy && <Spinner/>}{copy.action}</Btn></div>
    </DialogContent>
  </Dialog>;
};